import React from "react"
import {Check} from 'lucide-react'

interface ProblemSelectorProps {
  selectedProblem: string
  onSelectProblem: (problem: string) => void
}

const problems = [
  {
    id: "fibonacci",
    name: "Fibonacci Sequence",
    difficulty: "Easy",
    description: "The 'Hello World' of Dynamic Programming",
    timeComplexity: "O(n)",
    spaceComplexity: "O(n)"
  },
  {
    id: "knapsack",
    name: "0/1 Knapsack",
    difficulty: "Medium",
    description: "Most common interview question",
    timeComplexity: "O(n*W)",
    spaceComplexity: "O(n*W)"
  },
  {
    id: "lcs",
    name: "Longest Common Subsequence",
    difficulty: "Medium",
    description: "String matching algorithm",
    timeComplexity: "O(m*n)",
    spaceComplexity: "O(m*n)"
  },
  {
    id: "stairs",
    name: "Climbing Stairs",
    difficulty: "Easy",
    description: "Classic counting problem",
    timeComplexity: "O(n)",
    spaceComplexity: "O(n)"
  },
  {
    id: "coinchange",
    name: "Coin Change",
    difficulty: "Medium",
    description: "Minimum coins problem",
    timeComplexity: "O(n*amount)",
    spaceComplexity: "O(amount)"
  }
]

const difficultyColors = {
  Easy: "bg-emerald-500/20 text-emerald-400 border-emerald-500/30",
  Medium: "bg-amber-500/20 text-amber-400 border-amber-500/30",
  Hard: "bg-red-500/20 text-red-400 border-red-500/30"
}

export default function ProblemSelector({ selectedProblem, onSelectProblem }: ProblemSelectorProps) {
  return (
    <section id="visualizer" className="mb-12">
      <h2 className="text-3xl font-bold mb-6">Select a Problem</h2>
      <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-4">
        {problems.map((problem) => (
          <button
            key={problem.id}
            onClick={() => onSelectProblem(problem.id)}
            className={`text-left p-6 rounded-xl border-2 transition-all ${
              selectedProblem === problem.id
                ? "border-cyan-500 bg-cyan-500/10 shadow-lg shadow-cyan-500/20"
                : "border-slate-700 bg-slate-900/50 hover:border-slate-600 hover:bg-slate-900"
            }`}
          >
            <div className="flex items-start justify-between mb-3">
              <h3 className="text-lg font-semibold">{problem.name}</h3>
              {selectedProblem === problem.id && (
                <div className="w-6 h-6 bg-cyan-500 rounded-full flex items-center justify-center">
                  <Check className="w-4 h-4 text-white" />
                </div>
              )}
            </div>
            
            <p className="text-slate-400 text-sm mb-3">{problem.description}</p>
            
            <div className="flex items-center gap-2 mb-3">
              <span className={`text-xs px-2 py-1 rounded border ${difficultyColors[problem.difficulty as keyof typeof difficultyColors]}`}>
                {problem.difficulty}
              </span>
            </div>
            
            <div className="text-xs text-slate-500">
              <div>Time: {problem.timeComplexity}</div>
              <div>Space: {problem.spaceComplexity}</div>
            </div>
          </button>
        ))}
      </div>
    </section>
  )
}
